package one.healthium.player

import kotlinx.browser.document
import kotlinx.browser.window
import one.healthium.base.launcher.PlatformLauncher
import org.w3c.dom.HTMLDivElement
import org.w3c.dom.HTMLVideoElement
import org.w3c.dom.events.Event

actual class ModalVideoPlayer actual constructor(
    private val url: String,
    private val isMute: Boolean
) {
    private var videoElement: HTMLVideoElement? = null
    private var container: HTMLDivElement? = null
    private var closeButton: HTMLDivElement? = null

    actual fun present(platformLauncher: PlatformLauncher) {
        // Создаем контейнер для модального окна
        container = (document.createElement("div") as HTMLDivElement).apply {
            style.position = "fixed"
            style.top = "0"
            style.left = "0"
            style.width = "100vw"
            style.height = "100vh"
            style.backgroundColor = "rgba(0, 0, 0, 0.9)"
            style.zIndex = "9999"
            style.display = "flex"
            style.alignItems = "center"
            style.justifyContent = "center"
            style.flexDirection = "column"
        }

        // Создаем кнопку закрытия
        closeButton = (document.createElement("div") as HTMLDivElement).apply {
            innerHTML = "✕"
            style.position = "absolute"
            style.top = "20px"
            style.right = "20px"
            style.color = "white"
            style.fontSize = "32px"
            style.cursor = "pointer"
            style.zIndex = "10000"
            style.setProperty("user-select", "none")
            style.padding = "10px"

            addEventListener("click", {
                dispose()
            })
        }

        // Создаем видео элемент
        videoElement = (document.createElement("video") as HTMLVideoElement).apply {
            src = url
            controls = true
            autoplay = true
            muted = isMute
            style.maxWidth = "90vw"
            style.maxHeight = "90vh"
            style.outline = "none"
            loop = true
            setAttribute("playsinline", "")

            // Обработчик завершения видео (для браузеров, которые игнорируют loop)
            addEventListener("ended", { _: Event ->
                currentTime = 0.0
                play()
            })
        }

        container?.apply {
            closeButton?.let { appendChild(it) }
            videoElement?.let { appendChild(it) }
            document.body?.appendChild(this)
        }

        // Закрытие по клику на фон
        container?.addEventListener("click", { event ->
            if (event.target == container) {
                dispose()
            }
        })

        // Закрытие по ESC
        window.addEventListener("keydown", { event ->
            val keyboardEvent = event.asDynamic()
            if (keyboardEvent.key == "Escape" || keyboardEvent.keyCode == 27) {
                dispose()
            }
        })
    }

    fun dispose() {
        videoElement?.pause()
        videoElement?.remove()
        closeButton?.remove()
        container?.remove()
        videoElement = null
        closeButton = null
        container = null
    }
}